// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jcAG","col":"styles_col__2s8Pn"};